import { defineMessages } from "react-intl"

export default defineMessages({
  headerControllerExperience: {
    id: "app.pages.profile.GamingHabits.headerControllerExperience",
  },
  headerGamingExperience: {
    id: "app.pages.profile.GamingHabits.headerGamingExperience",
  },
  personal: {
    id: "app.pages.profile.GamingHabits.personal",
  },
  multiplayer: {
    id: "app.pages.profile.GamingHabits.multiplayer",
  },
})

